import React from 'react';

import { Partner, PostPartner } from '@models/next/Partner';

export interface PartnerContextValuesBase {
  type: 'create' | 'update';
  partnerId?: number;
  open: boolean;
  onClose: () => void;
  editContact?: boolean;
}

export interface PartnerContextValues extends PartnerContextValuesBase {
  item?: Partner;
  initialOutput: PostPartner;
}

export const PartnerContext = React.createContext<PartnerContextValues>({} as any);
